module.exports = __webpack_public_path__ + "static/media/mountain-logo.34d97d8d.svg";